import Vue from 'vue';

Vue.prototype.$getTranslation = function (messageKey, ...parameters) {
  let message = window.jsMessageKeys[messageKey];

  if (message && parameters) {
    parameters.forEach((parameter, index) => {
      message = message.replace(`{${index}}`, parameter);
    })

    return message;
  } else {
    return message || messageKey;
  }
};

export function initSearchSuggest() {
  const el = document.querySelector('.js-vue-searchsuggest');

  new Vue({
    el: el,
    components: {
      SearchSuggest: () => import('./components/SearchSuggest.vue')
    }
  })
}
